export class AbortToken {
    constructor(executor) {
        this.executor = executor;
    }
    getSignal() {
        const controller = new AbortController();
        const signal = controller.signal;
        this.executor(controller);
        return signal;
    }
}
